<div class="dont-print" *ngIf="!hasSidebar && !isLoginPage"> 
  <div class="slab-lang">
    <div>
      <button 
        *ngFor="let lang of langs"
        (click)="setLang(lang.code)" 
        class="button is-small"
        [class.is-light]="!isLangActive(lang.code)"
        [class.is-info]="isLangActive(lang.code)"
       data-ui-name="Set Lang" data-ui-component="header" data-testid="header-set-lang" [attr.data-entity-key]="lang.code" data-entity-type="lang">{{lang.caption}}</button>
      <button
        *ngIf="langService.isUsingLiveTranslations()"
        class="button is-small is-danger"
        (click)="langService.deactivateLiveTranslations()"
       data-ui-name="LIVE UPDATE" data-ui-component="header" data-testid="header-live-update">LIVE UPDATE</button>
    </div>
    <div style="display: flex; flex-direction: row;">
      <div style="display: flex; flex-direction: row; align-items: center; margin-inline: 1em;" *ngIf="isLoggedIn()  && false">
        <a routerLink="/en/test-auth/notifications" data-ui-name="En test auth notifications" data-ui-component="header" data-testid="header-en-test-auth-notifications">
          <div style="display: flex; align-items: center">
            <i style="font-size: 1.25em"class="fas fa-bell" aria-hidden="true"></i>&nbsp;{{getNotificationsText()}}
          </div>
        </a>
        <!-- <i *ngIf="notifications.hasUnreadPersonal" class="fas fa-circle" style="color: red; font-size: 0.4em; margin-top: -2em"></i> -->
      </div>
      <div style="display: flex; flex-direction: row; align-items: center" *ngIf="isLoggedIn()">
        <a routerLink="/{{langService.c()}}/message-centre" data-ui-name="Centre messag" data-ui-component="header" data-testid="header-centre-messag">
          <div style="display: flex; align-items: center">
            <i style="font-size: 1.25em"class="fas fa-bell" aria-hidden="true"></i>&nbsp;
            <tra slug="lbl_centre_messag"></tra>
            <span *ngIf="notifications.unreadNotifications().length > 0">&nbsp;({{notifications.unreadNotifications().length}})</span>
          </div>
        </a>
        <i *ngIf="notifications.unreadNotifications().length > 0" class="fas fa-circle" style="color: red; font-size: 0.4em; margin-top: -2em"></i>
      </div>
    </div>
  </div>
  <div class="slab-site-account" *ngIf="!hasSidebar">
    <div class="site-title">
      <a *ngIf="!isLoginHidden" class="is-title" [routerLink]="getHomeScreenRoute()" data-ui-name="Get Home Screen Route" data-ui-component="header" data-testid="header-get-home-screen-route">
        <tra [slug]="getBranding()"></tra>
      </a> 
      <!-- <a routerLink="/en/test-auth/dashboard">Authoring</a>
      <a routerLink="/en/test-ctrl/dashboard">Test Control</a> -->
    </div>
    <div class="profile-formlet">
      <div *ngIf="!userInfo">
        <a [routerLink]="getLoginRoute()"  data-ui-name="Title login" data-ui-component="header" data-testid="header-title-login">
          <tra slug="title_login"></tra>
        </a>
      </div>
      <div *ngIf="userInfo">
        <div [ngSwitch]="!!accountInfo" class="user-display-name">

          <span *ngIf="newMessage" (click)="onClickNewMessage()" data-ui-name="On Click New Message" data-ui-component="header" data-testid="header-on-click-new-message">
            <a [routerLink]="'/en/chat/' + messagePoolId" data-ui-name="En chat     message Pool Id" data-ui-component="header" data-testid="header-en-chat-message-pool-id"> <i class="fa fa-envelope" aria-hidden="true"></i> </a>|
          </span>

          <span *ngSwitchCase="true"> <a [routerLink]="accountInfo" data-ui-name="Account Info" data-ui-component="header" data-testid="header-account-info">{{getUserDisplayName()}}</a>  </span>
          <span *ngSwitchCase="false">{{getUserDisplayName()}}</span>
        </div>
        <div style="margin-bottom: 1em; opacity:0.8; font-size:0.7em;">
          <div class="timezone-indicator"><b>Timezone: </b>{{timeZone}}</div>
        </div>
        <div>
          <button *ngIf="!isLogoutHidden" class="button is-small is-outlined is-danger" style="margin-right:0em ;" (click)="logout()" data-ui-name="Title logout" data-ui-component="header" data-testid="header-title-logout">
              <tra slug="title_logout"></tra>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="color-strip" *ngIf="!hasSidebar" [ngStyle]="{'background-color':getStripColor()}"></div>
  <div class="slab-breadcrumb" role="navigation" aria-label="Breadcrumb" data-testid="header-breadcrumb" data-ui-name="Breadcrumb" data-ui-component="header">
    <div class="crumb-element">
      <a *ngIf="!isBreadcrumbMenuEnabled()" [routerLink]="getDashboardRoute()" [attr.aria-label]="langService.tra('lbl_home')" data-ui-name="Get Dashboard Route" data-ui-component="header" data-testid="header-get-dashboard-route"><i class="fa fa-home" aria-hidden="true"></i></a>
      <a class="crumb" (click)="toggleMenu()" style="font-weight:600" *ngIf="isBreadcrumbMenuEnabled()" data-ui-name="Menu" data-ui-component="header" data-testid="header-menu">Menu</a>
      <span *ngIf="breadcrumbPath && breadcrumbPath.length" class="crumb-delim">/</span>
    </div>
    <div class="crumb-element" *ngFor="let crumb of breadcrumbPath; let isLast = last">
      <a class="crumb" [routerLink]="crumb.route" [queryParams]="crumb.params" [attr.aria-current]="isLast ? 'page' : null" data-ui-name="Crumb route" data-ui-component="header" data-testid="header-crumb-route">{{langService.tra(crumb.caption)}}</a>
      <span *ngIf="!isLast" class="crumb-delim">/</span>
    </div>
  </div>
  <div *ngIf="isMenuRevealed" class="slab-breadcrumb buttons" style="border-top:1px solid #ccc;">
    <a class="button is-small" routerLink="/{{langService.c()}}/applicant/landing" data-ui-name="Tab test app" data-ui-component="header" data-testid="header-tab-test-app"><tra slug="tab_test_app"></tra></a>
    <a class="button is-small" routerLink="/{{langService.c()}}/testadmin/landing" data-ui-name="Tab test admin" data-ui-component="header" data-testid="header-tab-test-admin"><tra slug="tab_test_admin"></tra></a>
  </div>
</div>

<div class="dont-print simple-header has-sidebar" [class.is-opaque]="isOpaque" *ngIf="hasSidebar">
  <div class="slab-breadcrumb" role="navigation" aria-label="Breadcrumb" data-testid="header-breadcrumb" data-ui-name="Breadcrumb" data-ui-component="header">
    <div class="crumb-element">
      <a (click)="goBackHome()" role="link"  [attr.aria-label]="langService.tra('lbl_home')" tabindex="0" data-ui-name="Go Back Home" data-ui-component="header" data-testid="header-go-back-home"><i class="fa fa-home"></i></a>
      <span *ngIf="breadcrumbPath && breadcrumbPath.length" class="crumb-delim">/</span>
    </div>
    <div class="crumb-element" *ngFor="let crumb of breadcrumbPath; let isLast = last">
      <a class="crumb" [routerLink]="crumb.route" [queryParams]="crumb.params" [attr.aria-current]="isLast ? 'page' : null" data-ui-name="Crumb route" data-ui-component="header" data-testid="header-crumb-route-6b14f85">{{langService.tra(crumb.caption)}}</a>
      <span *ngIf="!isLast" class="crumb-delim">/</span>
    </div>
  </div>
  <div style="display: flex; flex-direction: row; align-items: center;">
    <button *ngIf="!hideSupportBtn" (click)="supportReqActivate()" class="support-link" data-ui-name="Title feedback" data-ui-component="header" data-testid="header-title-feedback">
      <tra whitelabel="tech_support" slug="title_feedback"></tra>
    </button>
    <ng-content></ng-content>
    <ntf-new-messages [isHeader]="true" *ngIf="isLoggedIn() && !hideMessageCentre" data-ui-name="Ntf new messages" data-ui-component="header" data-testid="header-ntf-new-messages"></ntf-new-messages>
    <!-- <div *ngIf="!isEnglish()" class="mutable-lang-select">
      <a (click)="setLang('en')" style="margin-left:0.3em;">English</a>
    </div>
    <div *ngIf="isEnglish()" class="mutable-lang-select">
      <img src="https://eqao.vretta.com/authoring/user_uploads/21/authoring/France_flag%201/1601053949477/France_flag%201.png">
      <a (click)="setLang('fr')">Français</a>
    </div> -->
  </div>
</div>

<div class="dont-print simple-header is-light" *ngIf="isLoginPage">
  <div>
    <div class="slab-breadcrumb" role="navigation" aria-label="Breadcrumb" data-testid="header-breadcrumb" data-ui-name="Breadcrumb" data-ui-component="header">
      <div class="crumb-element">
        <a [routerLink]="getDashboardRoute()" [attr.aria-label]="langService.tra('lbl_home')"  data-ui-name="Get Dashboard Route" data-ui-component="header" data-testid="header-get-dashboard-route-05b3bf1"><i class="fa fa-home" aria-hidden="true"></i></a>
        <span *ngIf="breadcrumbPath && breadcrumbPath.length" class="crumb-delim">/</span>
      </div>
      <div class="crumb-element" *ngFor="let crumb of breadcrumbPath; let isLast = last">
        <a class="crumb" [routerLink]="crumb.route" [queryParams]="crumb.params" [attr.aria-current]="isLast ? 'page' : null" data-ui-name="Crumb route" data-ui-component="header" data-testid="header-crumb-route-146e794">{{langService.tra(crumb.caption)}}</a>
        <span *ngIf="!isLast" class="crumb-delim">/</span>
      </div>
    </div>
    <div>
      <img *ngIf="isEnglish()"  style="max-width: 9em;" [src]="getWhitelabelUrl('header_logo_en')" [alt]="langService.tra(getBranding())">
      <img *ngIf="!isEnglish()" style="max-width: 9em;" [src]="getWhitelabelUrl('header_logo_fr')" [alt]="langService.tra(getBranding())">
    </div>
  </div>
  <div *ngIf="false">
    <div *ngIf="!isEnglish()" class="mutable-lang-select">
      <a (click)="setLang('en')" style="margin-left:0.3em;" data-ui-name="English" data-ui-component="header" data-testid="header-english">English</a>
    </div>
    <div *ngIf="isEnglish()" class="mutable-lang-select">
      <!-- <img src="https://eqao.vretta.com/authoring/user_uploads/21/authoring/France_flag%201/1601053949477/France_flag%201.png"> -->
      <a (click)="setLang('fr')" data-ui-name="Français" data-ui-component="header" data-testid="header-fran-ais">Français</a>
    </div>
  </div>
</div>